<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="header-title mt-0">{{titles.domainListExpression}}</h4>
                    <b-row class="mb-2">
                        <TablePerPageSelect :perPage="perPage" @method="setPerPage"/>
                        <TableAddButton :nameButton="titles.domainAddExpression" :showAddButton="showAddButton"
                                        pathName="addSecteur"/>
                    </b-row>
                    <b-table
                            :current-page="currentPage"
                            :emptyText="titles.emptyData"
                            :fields="fields"
                            :items="items"
                            :per-page="0"
                            :responsive="true"
                            @sort-changed="sortingChanged"
                            class="vouchers-table"
                            id="team-table"
                            no-local-sorting
                            show-empty
                    >
                        <template #empty="scope">
                            <Loading v-if="inProgess"/>
                            <p class="emptyData" v-if="!inProgess">{{ scope.emptyText }}</p>
                        </template>
                        <template v-slot:cell(name)="data">
                            {{data.item.name}}
                            <span class="warningSpan" v-if="!data.item.isActive">
                                <a class="warning"
                                   data-placement="right"
                                   data-trigger="hover"
                                   title="Vous devez configurez vos packs"
                                   v-b-tooltip.hover.right="{customClass: 'tooltipWarning'}"
                                >
                                    <i class="fas fa-exclamation-triangle"></i>
                                </a>
                            </span>
                        </template>
                        <template v-slot:cell(enabled)="data">
                            <i
                                    class="fas fa-check font-20 text-success"
                                    v-if="data.value"
                            ></i>
                            <i
                                    class="fas fa-times font-20 text-danger"
                                    v-if="!data.value"
                            ></i>
                        </template>
                        <template v-slot:head(Actions)>
                            <TableIconFilter :showFilter="showFilter" @changeValShowFilter="changeValShowFilter"/>
                        </template>
                        <template class="search-input" v-if="showFilter" v-slot:top-row>
                            <TableFilterInput :placeholder=titles.placeholderNameDomain @method="debouncedFetchModules"
                                              name="name"/>
                        </template>
                        <template v-slot:cell(Actions)="data">
                            <TableEditInfoElement
                                    :params="{ domainId: data.item.id, domainItem: data.item, isEditable: isEditable }"
                                    name='UpdateSecteur'/>
                            <TableDeleteElement :id="data.item.id" @method="deleteDomaine"/>
                        </template>
                    </b-table>
                    <TablePagination :currentPage="currentPage" :perPage="perPage" :rows="rows"
                                     @method="setCurrentPage"/>
                </div>
                <!--end card-body-->
            </div>
            <!--end card-->
        </div>
        <!--end col-->
    </div>
    <!--end row-->
</template>

<script>
    import {filterMixin} from '@/utils/filterMixin';
    import {debounce} from 'vue-debounce';
    import {getAllDomains} from '@/components/shared/services/domain.service';
    import {domain} from '@/components/shared/models/domain';
    import TablePerPageSelect from '@/components/common/TablePerPageSelect';
    import TablePagination from '@/components/common/TablePagination';
    import TableAddButton from '@/components/common/TableAddButton';
    import TableFilterInput from '@/components/common/TableFilterInput';
    import TableIconFilter from '@/components/common/TableIconFilter';
    import TableDeleteElement from '@/components/common/TableDeleteElement';
    import TableEditInfoElement from '@/components/common/TableEditInfoElement';
    import {titles} from '../../../utils/general/titles.js';
    import {updateDomaine} from '../../shared/services/domain.service';
    import Loading from '../../common/Loading';

    export default {
        name: 'Table',
        components: {
            Loading,
            TablePerPageSelect,
            TablePagination,
            TableAddButton,
            TableFilterInput,
            TableIconFilter,
            TableDeleteElement,
            TableEditInfoElement
        },
        created() {
            this.$cookies.remove('domainItem');
            this.$cookies.remove('domainItemIsEditable');
            this.orderQueryGenerator('id', true);
        },
        props: {
            okPressed: {
                type: Boolean,
                required: false
            },
            showAddButton: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                titles,
                domaineId: null,
                value: '',
                selected: null,
                filterList: [],
                filterQuery: '',
                expires: 0,
                txtInput: '',
                sort: '',
                perPage: 10,
                currentPage: 1,
                showFilter: false,
                rows: null,
                sortType: '',
                fields: [
                    {key: 'name', label: 'Nom', sortable: true},
                    {key: 'url', label: 'Url', sortable: true},
                    {key: 'enabled', label: 'Statut', sortable: false},
                    {key: 'Actions', sortable: false}
                ],
                items: [],
                isEditable: true,
                inProgess: true
            };
        },
        mixins: [filterMixin],
        methods: {
            openDetailsModal(actualDomain) {
                this.$emit('getDomaine', actualDomain);
                this.$bvModal.show('domain-detail');
            },
            deleteDomaine(id) {
                this.$bvModal.show('delete-domain');
                this.domaineId = id;
            },
            sortingChanged(ctx) {
                this.orderQueryGenerator(ctx.sortBy, ctx.sortDesc);
                this.fetchDomains();
            },
            debouncedFetchModules: debounce(function (column, val, type, direction) {
                this.fetchDomains(column, val, type, direction);
            }, 300),
            changeValShowFilter(val) {
                this.showFilter = val;
            },
            setCurrentPage(val) {
                this.currentPage = val;
            },
            setPerPage(val) {
                this.perPage = val;
            },
            async fetchDomains(column, val, type) {
                this.inProgess = true;
                this.items = [];
                if (column) {
                    this.filterList = this.filterQueryGenerator(
                        this.filterList,
                        column,
                        val,
                        type
                    );
                }
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'deleted',
                    '0',
                    null
                );
                getAllDomains(
                    this.perPage,
                    this.currentPage,
                    this.sort,
                    this.filterQuery
                ).then(response => {
                    this.items = response.data['hydra:member'];
                    this.items = this.items.map(
                        function (item) {
                            return domain(item);
                        }
                    );
                    this.rows = response.data['hydra:totalItems'];
                    this.inProgess = false;
                });
            }
        },
        mounted() {
            this.fetchDomains();
        },
        watch: {
            okPressed() {
                if (this.okPressed) {
                    const actualDomain = this.items.find(item => item.id == this.domaineId);
                    if (actualDomain.isActive == true) {
                        this.$emit('deleted', false);
                        this.$bvModal.show('error-delete-domain');
                    } else {
                        actualDomain.enabled = false;
                        actualDomain.isActive = false;
                        actualDomain.deleted = true;
                        updateDomaine(this.domaineId, actualDomain).then(
                            response => {
                                this.fetchDomains();
                                this.$emit('deleted', false);
                                this.$bvModal.show('success-delete-domain');
                                return response;
                            },
                            error => {
                                this.showError(error);
                            }
                        );
                    }
                }
            },
            currentPage: {
                handler() {
                    this.fetchDomains();
                }
            },
            perPage: {
                handler() {
                    this.fetchDomains();
                }
            }
        }
    };
</script>

<style type="scss">
    @import '../../../assets/style/css/appStyle.css';
    @import '../../../assets/style/css/share/table.css';
</style>
